export type ResultType<T> = Ok<T>|Err

interface Ok<T> { value: T, Err: null }
interface Err { value: null, Err: Error }

export async function Result<T,P>( fn: (...value: Array<P>) => T|Promise<T> ): Promise<ResultType<T>> {
	try {
		const res = await fn()
		return { 
			value: res, 
			Err: null
		}

	} catch(e) {
		const err = ( e instanceof Error ) ? e : new Error("Unknown error", { cause: { err: e }}) 
		return { value: null, Err: err }
	}	
}


export function ResultSync<T,P>( fn: (...value: Array<P>) => T ): ResultType<T> {
	try {
		const res = fn()
		return { 
			value: res, 
			Err: null
		}

	} catch(e) {
		const err = ( e instanceof Error ) ? e : new Error("Unknown error", { cause: { err: e }}) 
		return { value: null, Err: err }
	}	
}